import React, { useMemo } from 'react';
import LocalOpsSheet from './LocalOpsSheet';
import PostMediaCarousel from '../post/PostMediaCarousel';
import { normalizeMediaList } from '../../utils/postMediaUtils';

const getStatusLabel = (status) => {
  if (status === 'completed') return 'Completed';
  return 'Live now nearby';
};

export default function LocalOpsShareSheet({
  open,
  type,
  item,
  status,
  onClose,
  onShare,
  onView,
}) {
  const mediaList = useMemo(
    () => (item ? normalizeMediaList(item) : []),
    [item],
  );
  const title = item?.title || item?.name || item?.meta?.title || 'LocalOps';
  const category =
    item?.category || item?.offeringType || item?.taskType || 'LocalOps';
  const statusLabel = getStatusLabel(status);

  if (!open) return null;

  return (
    <LocalOpsSheet open={open} onClose={onClose} title="LocalOps Live">
      <div className="localops-success-card">
        <div className="localops-success-title">{statusLabel}</div>
        <div className="localops-success-subtitle">
          {type === 'task'
            ? 'Your task is ready for nearby helpers.'
            : 'Your offering is now visible nearby.'}
        </div>
        <div className="localops-chip-group">
          <span className="localops-pill-chip">{category}</span>
          <span className="localops-pill-chip">{statusLabel}</span>
        </div>
        <div className="localops-preview-title">{title}</div>
        {mediaList.length ? (
          <div className="localops-media-hero">
            <PostMediaCarousel item={item} autoPlay={false} enableZoom />
          </div>
        ) : null}
        {type === 'offering' ? (
          <>
            <div className="localops-helper">
              You just made something locally available.
            </div>
            <div className="localops-helper">
              When it's found and used, value stays nearby.
            </div>
          </>
        ) : null}
        {status !== 'completed' ? (
          <>
            <div className="localops-success-actions">
              <button type="button" className="localops-btn" onClick={onShare}>
                Share & Earn JGK
              </button>
              <button
                type="button"
                className="localops-btn localops-btn--ghost"
                onClick={onView}
              >
                View on map
              </button>
            </div>
            <div className="localops-helper">Earn JGK for sharing LocalOps.</div>
          </>
        ) : null}
      </div>
    </LocalOpsSheet>
  );
}
